import { render, staticRenderFns } from "./ApplyToAllShapes.vue?vue&type=template&id=0578f32c"
import script from "./ApplyToAllShapes.vue?vue&type=script&lang=js"
export * from "./ApplyToAllShapes.vue?vue&type=script&lang=js"
import style0 from "./ApplyToAllShapes.vue?vue&type=style&index=0&id=0578f32c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports